import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const DEPARTMENT_RESTORE_RESOURCE = "department" as const;
export const DEPARTMENT_RESTORE_API_PATH = `/v1/${DEPARTMENT_RESTORE_RESOURCE}/{uuid}/restore` as const;

export type DepartmentRestoreResponse =
  paths[typeof DEPARTMENT_RESTORE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useDepartmentRestoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<DepartmentRestoreResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<DepartmentRestoreResponse>(
        `/v1/${DEPARTMENT_RESTORE_RESOURCE}/${uuid}/restore`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [DEPARTMENT_RESTORE_RESOURCE],
      });
    },
  });
};
